import { toast } from "react-toastify";
import Layout from "../../../components/Layout";
import { Grid, useMediaQuery } from "@mui/material";
import { httprequest } from "../../../data/api";
import { useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import BreadCrumb from "../../../components/BreadCrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";

const CLASSES_ENDPOINT = "/api/v1/class";
const GET_SESSIONS = "/api/v1/school-plan/session";

const ClassPromotion = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const navigate = useNavigate();

  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const handleSessionChange = (e) => {
    const sessionId = e.target.value;
    const selectedSession = allSessions.find(sesh => sesh.id === sessionId);
    setActiveSession(selectedSession);
    // getSessionReport(sessionId, selectedClass);
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);
    // if (activeSession?.id) {
    //   getSessionReport(activeSession.id, classId);
    // }
  };

  const data = [
    { id: 1, name: "Eugene Adavore", term1: 50, term2: 50, term3: 50, sessionResult: 50 },
    { id: 2, name: "Patrick Steve", term1: 50, term2: 50, term3: 50, sessionResult: 50 },
    { id: 3, name: "Marins Otoruncolo", term1: 50, term2: 50, term3: 50, sessionResult: 50 },
    { id: 4, name: "Goodnews Akpan", term1: 50, term2: 50, term3: 50, sessionResult: 50 },
    { id: 5, name: "Caxton Strange", term1: 50, term2: 50, term3: 50, sessionResult: 50 },
    { id: 6, name: "Santico Onachukwu", term1: 50, term2: 50, term3: 50, sessionResult: 50 }
  ];

  const columns = [
    {
      name: "Names",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Names</p>}
          {row.name}
        </>
      ),
      sortable: true
    },
    {
      name: "1st Term",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">1st Term</p>}
          {row.term1}
        </>
      ),
      sortable: true
    },
    {
      name: "2nd Term",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">2nd Term</p>}
          {row.term2}
        </>
      ),
      sortable: true
    },
    {
      name: "3rd Term",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">3rd Term</p>}
          {row.term3}
        </>
      ),
      sortable: true
    },
    {
      name: "Session Result",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Session Result</p>}
          {row.sessionResult}
        </>
      ),
      sortable: true
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate("/report/sessionreport")}>
            <Icon icon="hugeicons:view" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    getAllClasses();
    getAllSessions();
  }, []);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/report/promotion"
              link_one_name="Promotion"
              active="Jss1"
              description="Manage students promotions."
            />
          </div>
          <div className="flex gap-10">
            <div>
              {activeSession?.id && (
                <SelectGroup
                  children={
                    <select
                      defaultValue={activeSession?.id}
                      onChange={handleSessionChange}
                      name="session"
                    >
                      <option value="">---Select---</option>
                      {allSessions?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </div>

          </div>
        </div>

        <div className="page-content margin-top-30">
          <Table
            data={data}
            columns={columns}
            subHeader={false}
            pagination
          />

          <div className="flex gap-10 margin-top-30 text-center">
            <Grid container spacing={2} className="text-center">
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <SelectGroup
                  children={
                    <select onChange={handleClassChange} name="term" value={selectedClass}>
                      <option value="">--All Class--</option>
                      {classesData?.map((data) => {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.class_name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Apply Promotion"
                />
              </Grid>
            </Grid>
          </div>
        </div>
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default ClassPromotion;
